/**
 * @generated SignedSource<<386f5f9a9d62afa3e37447d980f340fc>>
 * @relayHash edbc9e6495a22149e969b9eaec266328
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6d15832e4c548dbf729e8d0d86ee94db5fc8377721311a5b6c4d20052e01dbd

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueTypeFilterInput = {
  maxHierarchyLevel?: number | null | undefined;
  minHierarchyLevel?: number | null | undefined;
};
export type IssueTypeDropdownQuery$variables = {
  cloudId: string;
  filter?: JiraIssueTypeFilterInput | null | undefined;
  hasProjectKey: boolean;
  projectKey: string;
};
export type IssueTypeDropdownQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey?: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueTypeDropdown">;
    };
  };
};
export type IssueTypeDropdownQuery = {
  response: IssueTypeDropdownQuery$data;
  variables: IssueTypeDropdownQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": isInlineManageWorkTypesConfigNinIccEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider: {
    readonly get: () => boolean;
  };
});

import isInlineManageWorkTypesConfigNinIccEnabled_provider from '@atlassian/jira-relay-provider/src/jira-nin-inline-manage-work-type-config.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasProjectKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v5 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueTypeDropdownQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "condition": "hasProjectKey",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v4/*: any*/),
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jiraProjectByKey",
                    "plural": false,
                    "selections": [
                      {
                        "args": [
                          (v5/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "IssueTypeDropdown"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.jiraProjectByKey"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "IssueTypeDropdownQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "hasProjectKey",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "projectId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  (v7/*: any*/),
                  {
                    "concreteType": "JiraAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "large"
                      }
                    ]
                  },
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "JiraIssueTypeConnection",
                    "kind": "LinkedField",
                    "name": "issueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "issueTypeId"
                              },
                              (v7/*: any*/),
                              {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "small"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                "kind": "LinkedField",
                                "name": "hierarchy",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "level"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              {
                                "alias": "value",
                                "kind": "ScalarField",
                                "name": "id"
                              },
                              {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "name"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v8/*: any*/),
                    "filters": [
                      "filter"
                    ],
                    "handle": "connection",
                    "key": "inlineIssueCreate_IssueTable_issueTypes",
                    "kind": "LinkedHandle",
                    "name": "issueTypes"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b6d15832e4c548dbf729e8d0d86ee94db5fc8377721311a5b6c4d20052e01dbd",
    "metadata": {},
    "name": "IssueTypeDropdownQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": isInlineManageWorkTypesConfigNinIccEnabled_provider
    }
  }
};
})();

(node as any).hash = "0238e0aca7edc4704b3aa7f61762f162";

export default node;
